import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from "../../../../../../../../../../libs/immer";
import { unformatValue, validateAccountNumber } from "./utils";
// Validates a phone number input and updates UI state accordingly
export var validatePhoneUseCase = function validatePhoneUseCase(_ref) {
  var getContent = _ref.getContent,
    getIsBeelineError = _ref.getIsBeelineError;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value, setState) {
      var result, error, _error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Clean up the input value
            result = unformatValue(value); // Disable input and show loading state
            disableAndShowLoading(setState);
            _context.prev = 2;
            _context.next = 5;
            return validateAccountNumber(result, getIsBeelineError, getContent().phoneInputErrorTexts);
          case 5:
            error = _context.sent;
            // Update UI with error message if any
            updateErrorMessage(setState, error !== null && error !== void 0 ? error : '');
            return _context.abrupt("return", error);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            // Log error and show default error message on failure
            console.error(_context.t0);
            _error = getContent().phoneInputErrorTexts.default;
            updateErrorMessage(setState, _error);
            return _context.abrupt("return", _error);
          case 16:
            _context.prev = 16;
            // Always re-enable input and hide loading state
            enableAndHideLoading(setState);
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 10, 16, 19]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

// Helper function to disable input and show loading
function disableAndShowLoading(setState) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.phoneInput.isDisabled = true;
      draft.phoneInput.isLoading = true;
    });
  });
}

// Helper function to enable input and hide loading
function enableAndHideLoading(setState) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.phoneInput.isDisabled = false;
      draft.phoneInput.isLoading = false;
    });
  });
}

// Helper function to update the error message
function updateErrorMessage(setState, errorMessage) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.phoneInput.errorMessage = errorMessage;
    });
  });
}